$(document).ready(function () {
    /*adding promo code -- start*/
    $('#cart-add-promo-code').on('click', function() {
        $(this).next('.promo__form').addClass('active');
        $(this).addClass('hide');
    });

    $(document).mouseup( function(e){ // событие клика по веб-документу
        var promoFormCode = $( '#cart-promo-form-code' ); // тут указываем ID элемента
        if ( !promoFormCode.is(e.target) // если клик был не по нашему блоку
            && promoFormCode.has(e.target).length === 0 ) { // и не по его дочерним элементам
            promoFormCode.removeClass('active'); // скрываем его
            $('#cart-add-promo-code').removeClass('hide');

            promoFormCode
                .find('[data-entity="basket-coupon-not-found"], [data-entity="basket-coupon-found"]')
                .remove()
        }
    });
    /*adding promo code -- end*/

    /*adding certificate code -- start*/
    $('#cart-add-certificate').on('click', function() {
        $(this).next('.promo__form').addClass('active');
        $(this).addClass('hide');
    });

    $(document).mouseup( function(e){ // событие клика по веб-документу
        var promoFormCode = $( '#cart-promo-form-certificate' ); // тут указываем ID элемента
        if ( !promoFormCode.is(e.target) // если клик был не по нашему блоку
            && promoFormCode.has(e.target).length === 0 ) { // и не по его дочерним элементам
            promoFormCode.removeClass('active'); // скрываем его
            $('#cart-add-certificate').removeClass('hide');
        }
    });
    /*adding certificate code -- end*/

    /*certificate - only numbers & symbols count mask -- start*/
    $("#cart-promo-input-certificate").keydown(function(event) {
        // Разрешаем: backspace, delete, tab и escape
        if ( event.keyCode == 46 || event.keyCode == 8 || event.keyCode == 9 || event.keyCode == 27 ||
            // Разрешаем: Ctrl+A
            (event.keyCode == 65 && event.ctrlKey === true) ||
            // Разрешаем: home, end, влево, вправо
            (event.keyCode >= 35 && event.keyCode <= 39)) {

            // Ничего не делаем
            return;
        } else {
            // Запрещаем все, кроме цифр на основной клавиатуре, а так же Num-клавиатуре
            if ((event.keyCode < 48 || event.keyCode > 57) && (event.keyCode < 96 || event.keyCode > 105 )) {
                event.preventDefault();
            }
        }
    });

    /*input mask for certificate*/
    $('input#cart-promo-input-certificate').mask('0 000000 000000');

    /*certificateOwnPrice - only numbers & symbols count mask -- end*/

    //---Product counter in cart -- start --//
    // let btnsMinusArray = document.querySelectorAll('.cart .counter__minus');
    // let btnsPlusArray = document.querySelectorAll('.cart .counter__plus');
    //
    // for (let btn of btnsMinusArray) {
    //
    //     btn.onclick = function() {
    //
    //         let numberOfProductsElem = this.nextElementSibling;
    //         let countMinus = numberOfProductsElem.innerHTML;
    //
    //         if(countMinus >= 2){
    //             numberOfProductsElem.innerHTML--;
    //         } else {
    //            btnsMinusArray.classList.add('disabled');
    //         }
    //     };
    // };
    //
    // for (let btn of btnsPlusArray) {
    //
    //     btn.onclick = function() {
    //
    //         let numberOfProductsElem = this.previousElementSibling;
    //
    //         numberOfProductsElem.innerHTML++;
    //     };
    // };
    //---Product counter in cart -- end --//

    //---Product delete from cart -- start --//
    /*$('.cart .product__delete').on('click', function (e) {
        e.preventDefault();

        $(this).closest('.products__item').remove();
    });*/
    //---Product delete from cart -- end --//

    // delete promos
    $('.allPrice__item_edit .allPrice__item_text span.delete').on('click', function (e) {
        e.preventDefault();

        $(this).closest('.allPrice__item_edit').remove();
    });

    // on scroll
    /*Запускать скрипт только на странице корзины*/
    if ($('.cart.cart_new').length) {
        if ($(window).width() < 1040) {
            var $element = $('.allPrice__btn');
            let counter = 0;
            /*$(window).scroll(function() {
                var scroll = $(window).scrollTop() + $(window).height();
                //Если скролл до конца елемента
                //var offset = $element.offset().top + $element.height();
                //Если скролл до начала елемента
                var offset = $element.offset().top;

                if (scroll > offset && counter == 0) {
                    $('.cart__fix').hide();
                    counter = 1;
                } else if (scroll < offset) {
                    $('.cart__fix').css('display', 'flex');
                    counter = 0;
                }
            });*/
        }
    }

    // on hover
    $('.counter__btn_round.counter__plus.disabled').hover(function(){
        $(this).closest('.products__item').find('.warningBox').toggleClass('active');
    });

});
